'use client';

import PricingFeatureComparisonTable, {
  PricingFeatureComparisonTableProps,
} from '@/components/_rebrand/PricingFeatureComparisonTable';
import PricingHeroPlanComparison, {
  PricingHeroPlanComparisonProps,
} from '@/components/_rebrand/PricingHeroPlanComparison';
import { FC, Fragment, useState } from 'react';
import FaqDrawerList, { FaqDrawerListProps } from './FaqDrawerList';
import { PageBumper, PageBumperProps } from './PageBumper';
import PricingAddons, { PricingAddonsProps } from './PricingAddons';
import PricingCustomerStories, { PricingCustomerStoriesProps } from './PricingCustomerStories';

interface PricingPageProps {
  heroProps: PricingHeroPlanComparisonProps;
  tableProps: PricingFeatureComparisonTableProps;
  addonsProps: PricingAddonsProps;
  customerStoriesProps: PricingCustomerStoriesProps;
  faqProps: FaqDrawerListProps;
  bumperProps: PageBumperProps;
}

const PricingPage: FC<PricingPageProps> = ({
  heroProps,
  tableProps,
  addonsProps,
  customerStoriesProps,
  faqProps,
  bumperProps,
}) => {
  const [isYearlyPricingVisible, setYearlyPricingVisible] = useState(true);

  return (
    <Fragment>
      <PricingHeroPlanComparison
        {...heroProps}
        isYearlyPricingVisible={isYearlyPricingVisible}
        setYearlyPricingVisible={setYearlyPricingVisible}
      />
      <PricingFeatureComparisonTable
        {...tableProps}
        isYearlyPricingVisible={isYearlyPricingVisible}
        setYearlyPricingVisible={setYearlyPricingVisible}
      />
      <PricingAddons {...addonsProps} />
      <PricingCustomerStories {...customerStoriesProps} />
      <FaqDrawerList {...faqProps} />
      <PageBumper {...bumperProps} />
    </Fragment>
  );
};

export default PricingPage;
